import type { UserCreatePayload, UserUpdatePayload } from "src/types/user";
import User from "../models/user";
import Repository from "./repository";

const resource = "/users";

export default {
  create(user: UserCreatePayload) {
    return Repository.post(`${resource}/`, user);
  },
  async get() {
    const { data } = await Repository.get(`${resource}/me/`);
    return new User(data);
  },
  updateMe(user: UserUpdatePayload) {
    return Repository.patch(`${resource}/me/`, user);
  },
};
